import { Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
    selector: '[libWordBreak]',
    standalone: false
})
export class WordBreakDirective {
	constructor(private renderer: Renderer2, private hostElement: ElementRef) {
		this.setStyles();
	}

	setStyles(): void {
		if (this.hostElement.nativeElement) {
			this.renderer.setStyle(this.hostElement.nativeElement, 'word-break', 'break-word');
		}
	}
}
